import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var AndroidShareOutlineSVG = function AndroidShareOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M22 20a5 5 0 00-3.5 1.4l-4.3-2.8a4.9 4.9 0 00.1-5.1l4.3-2.9A5 5 0 0022 12a5 5 0 10-4.6-3L13 12a5 5 0 10-.1 8.1l4.5 3A5 5 0 0017 25a5 5 0 105-5zm0-16a3 3 0 11-3 3 3 3 0 013-3zM10 19a3 3 0 113-3 3 3 0 01-3 3zm12 9a3 3 0 113-3 3 3 0 01-3 3z"
  }));
};
AndroidShareOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AndroidShareOutlineSVG);